import React from "react"
import { useOutletContext } from "react-router-dom"
import styledComp from "styled-components"

import { useNavigate, useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"

import { Stack, Typography } from "@mui/material"
import CartNotification from "@features/cart/components/cart-notification"
import { GlobalProps } from "@layout/index"

const SubMenuButton = styledComp.button`
border: 0px;
text-decoration: none;
background-color: transparent;
display: flex;
justify-content: flex-start;
font-size: 0.8rem;
padding: 8px 8px;
border-radius: 4px;
font-weight: 400;
color:  ${({ theme }) => theme.palette.secondary.main};
cursor: pointer;
font-family: "Space Grotesk Variable", "Beatrice", "Poppins", sans-serif;
line-height: 1;

${(props: any) =>
  props.$current === "true" &&
  `
font-weight: 700;
background-color: ${props.theme.palette.background.default};
`}

&:hover {
  background-color: ${({ theme }) => theme.palette.background.default};
}
`

interface MenuRendererProps {
  menu: any
  handleNavigation: any
  jumpTo: any
  itsCartMenu: any
  getCurrentRoute: any
}

const MenuRenderer = ({
  menu,
  handleNavigation,
  jumpTo,
  itsCartMenu,
  getCurrentRoute,
}: MenuRendererProps) => {
  const { setAuth } = useOutletContext<GlobalProps>()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems={"center"}
        spacing={1}
        sx={(theme) => ({ color: theme.palette.primary.main })}
      >
        {menu.icon}
        <Typography variant="h6" sx={{ fontSize: "1.1rem" }}>
          {menu.label}
        </Typography>
      </Stack>
      <Stack spacing={0.5}>
        {menu.submenus.map((submenu: any, i: number) => (
          <SubMenuButton
            data-testid={submenu.route}
            key={i} // @ts-ignore
            $current={getCurrentRoute(location.pathname, `/${submenu.route}`)}
            onClick={() =>
              handleNavigation(
                dispatch,
                submenu.route,
                navigate,
                jumpTo,
                setAuth
              )
            }
          >
            <Stack
              justifyContent="space-between"
              direction="row"
              alignItems="center"
              sx={{ width: "95%" }}
            >
              {submenu.title}

              {itsCartMenu(menu, submenu) && <CartNotification />}
            </Stack>
          </SubMenuButton>
        ))}
      </Stack>
    </Stack>
  )
}

export default MenuRenderer
